"use client"

import { useRef, useEffect } from "react"
import { X, ImagePlus, Sparkles, Crown } from "lucide-react"

const UpsellModal = ({ isOpen, onClose, config = {} }) => {
  const { title, introText, features, highlightText, highlightDescription, children } = config

  const modalRef = useRef(null)

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [isOpen])

  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose()
    }
  }

  if (!isOpen) return null

  const renderDefaultContent = () => {
    const hasContent = introText || features || (highlightText && highlightDescription)
    if (!hasContent) return null

    return (
      <div className="space-y-6 py-4">
        {introText && <p className="text-gray-dark/80 leading-relaxed text-center text-sm">{introText}</p>}

        {features && (
          <div className="grid grid-cols-1 gap-4">
            {features.map((item, index) => (
              <div
                key={index}
                className="flex flex-col p-4 rounded-xl border border-gray-light/30 bg-white hover:bg-gray-50 transition-all duration-300 ease-out shadow-sm hover:shadow-md"
              >
                <div className="flex items-start gap-3">
                  <div className="p-2 rounded-lg bg-primary/10 text-primary">{item.icon}</div>
                  <div>
                    <h4 className="font-medium text-gray-dark mb-1">{item.title}</h4>
                    <p className="text-sm text-gray leading-relaxed">{item.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {highlightText && highlightDescription && (
          <div className="mt-6">
            <div className="rounded-xl border border-gray-light/30 p-4 flex items-center gap-4 bg-gradient-to-br from-white to-gray-50">
              <div className="bg-warning/10 p-2.5 rounded-lg shrink-0">
                <ImagePlus className="h-5 w-5 text-warning" />
              </div>
              <p className="text-sm text-gray-dark">
                <span className="font-semibold">{highlightText}</span> {highlightDescription}
              </p>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div
      className="fixed inset-0 modal-safe-area z-[10000] bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center p-4 overflow-y-auto"
      onClick={handleBackdropClick}
    >
      <div
        ref={modalRef}
        className="relative bg-white rounded-2xl w-full max-w-md lg:max-w-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] overflow-hidden animate-in fade-in-90 zoom-in-90 duration-300"
      >
        {/* Premium badge */}
        <div className="absolute left-0 top-6 bg-primary text-white text-xs font-medium py-1 px-3 rounded-r-full shadow-sm flex items-center gap-1.5">
          <Crown size={14} />
          <span>Próximamente</span>
        </div>

        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100"
          aria-label="Cerrar"
        >
          <X size={18} />
        </button>

        <div className="p-6 sm:p-8">
          <div className="flex flex-col items-center mb-6">
            <img src="/ch3.png" alt="Espor.ai" className="h-12 w-auto" />
          </div>

          <div className="flex items-center justify-center gap-1 mb-4">
            <Sparkles className="h-5 w-5 text-primary" />
            <h3 className="text-xl font-semibold text-gray-900 tracking-tight">{title}</h3>
          </div>

          <div className="text-sm text-gray-600 mb-6 max-h-[40vh] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent overscroll-contain">
            {children || renderDefaultContent()}
          </div>
          <div className="mt-4 pt-4 border-t border-gray-light/20">
            {/* 
            <p className="text-sm text-gray text-center">
              ¿Te gustaría que te avisemos cuando esto esté disponible?{" "}
              <span className="text-primary font-medium cursor-pointer hover:underline transition-colors">
                ¡Avísenme!
              </span>
            </p>
            */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpsellModal
